import * as BOOKING_ACTIONS from "../../../../../../store/booking/action-types";
import stepMixin from "../../../../../../utils/mixins/stepMixin.js";
import { GET_BOOKING_TRAVELLERS_TOTAL, GET_FLEX_EXTRAS, GET_FLEX_EXTRA_SELECTED } from '../../../../../../store/booking/getter-types';
import { NIGHTS_SET_PACK } from '../../../../../../store/nights/mutation-types';
import { mapGetters } from "vuex";
import { SET_FLEX_EXTRA_SELECTED } from "../../../../../../store/booking/mutation-types";
import FlexExtras from "../../../../../../components/FlexExtras.vue";
export default {
	mixins: [stepMixin],
  components: {
    FlexExtras
  },
  computed: {
    ...mapGetters({
      flexExtras: GET_FLEX_EXTRAS,
    }),
    extrasFiltered() {
      return this.booking.extras.available.filter(extra => {
        return extra.slug !== '' || this.$store.getters[GET_BOOKING_TRAVELLERS_TOTAL] !== 1;
      });
    },
    flexExtraSelected: {
      get() {
        return this.$store.getters[GET_FLEX_EXTRA_SELECTED];
      },
      set(value) {
        return this.$store.commit(SET_FLEX_EXTRA_SELECTED, value);
      }
    },
  
  },
  methods: {
    handleCheckboxChange(extraId) {
      this.$store.dispatch(BOOKING_ACTIONS.SELECT_BOOKING_EXTRA, extraId);
    },
    handleCounterChange(value, extraId){
      this.$store.dispatch(BOOKING_ACTIONS.SET_BOOKING_EXTRA_QUANTITY, {id: extraId, value: value});
    },
		submitStep(event) {
			this.stepComplete(this.activeStep);
    },
    setPackFlightToFalse() {
      this.$store.commit(NIGHTS_SET_PACK, false);
    }
  },
  created() {
    this.setPackFlightToFalse();
  }
};
